// extracted by mini-css-extract-plugin
module.exports = {"form":"Contact_form__1SlZ_"};